import React, { useRef, useEffect, useState } from 'react'
import { Dialog, AppBar, Toolbar, IconButton, Grid, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import YellowButton from './YellowButton'
import SignaturePad from './SignaturePad'
import { useTranslation } from 'react-i18next'

const FullScreenSignatureDialog = ({ open, title, onClose, onSave, initialPreview }) => {
    const { t } = useTranslation()
    const padRef = useRef(null)
    const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 })

    useEffect(() => {
        const resize = () => {
            const w = Math.min(window.innerWidth - 32, 1200)
            const h = Math.min(window.innerHeight - 200, 600)
            setCanvasSize({ width: w, height: h })
        }
        resize()
        window.addEventListener('resize', resize)
        return () => window.removeEventListener('resize', resize)
    }, [])

    const handleClear = () => {
        if (padRef.current) padRef.current.clear()
    }

    const handleSave = async () => {
        if (!padRef.current) return
        const blob = await padRef.current.getBlob()
        const dataUrl = padRef.current.getDataURL()
        if (onSave) onSave({ blob, dataUrl })
    }

    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <AppBar position="static" color="default" elevation={0}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Grid container justifyContent="center" alignItems="center" sx={{ p: 2 }}>
                <Grid item>
                    {initialPreview ? (
                        <img alt="signature" src={initialPreview} style={{ display: 'none' }} />
                    ) : null}
                    <SignaturePad ref={padRef} width={canvasSize.width} height={canvasSize.height} showClearButton={false} />
                    <Stack direction="row" spacing={1} sx={{ mt: 2, justifyContent: 'center' }}>
                        <YellowButton onClick={handleClear}>{'Temizle'}</YellowButton>
                        <YellowButton onClick={handleSave}>{t('save')}</YellowButton>
                    </Stack>
                </Grid>
            </Grid>
        </Dialog>
    )
}

export default FullScreenSignatureDialog


